<div [class.dark-theme]="true" class="fix-action-dialog" style="background: linear-gradient(#242424,#141414);">
	<mat-dialog-content>
		<div style="padding:16px; color: #424242;">
			<div class="card-title"></div>
		</div>
			<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>
				<div fxLayout="column" style="margin:16px 0 8px 0;font-size: 14px;">
					<div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
						<mat-form-field appearance="outline" fxFlex="100" style="height: 80px;">
							<mat-label><span data-idtest="payment-customer-update-dialog-t-5Hp" translate>名前</span></mat-label>
							<input data-idtest="payment-customer-update-dialog-i-1Xe" #name_field="ngModel" [(ngModel)]="content.name" autocomplete="off" matInput maxlength="100" name="name" required type="text" style="color: #ffffff">
							<mat-error *ngIf="name_field.errors?.['required'];"><span translate>入力してください</span></mat-error>
							<mat-error *ngIf="name_field.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
						</mat-form-field>
					</div>

					<div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
						<mat-form-field appearance="outline" fxFlex="100" style="height: 80px;">
							<mat-label><span data-idtest="payment-customer-update-dialog-t-6Wg" translate>電話番号</span></mat-label>
							<input data-idtest="payment-customer-update-dialog-i-5Di" #phone_field="ngModel" [(ngModel)]="content.phone" autocomplete="off" matInput maxlength="100" name="phone" required type="text" style="color: #ffffff">
							<mat-error *ngIf="phone_field.errors?.['required'];"><span translate>入力してください</span></mat-error>
							<mat-error *ngIf="phone_field.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
						</mat-form-field>
					</div>

					<div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
						<mat-form-field appearance="outline" fxFlex="100" style="height: 80px;">
							<mat-label><span data-idtest="payment-customer-update-dialog-t-7Go" translate>メールアドレス</span></mat-label>
							<input data-idtest="payment-customer-update-dialog-i-4Ii" #email_field="ngModel" [(ngModel)]="content.email" autocomplete="off" email matInput maxlength="255" name="email" required type="email" style="color: #ffffff">
							<mat-error *ngIf="email_field.errors?.['email'];"><span translate>有効なメールアドレスで</span></mat-error>
							<mat-error *ngIf="email_field.errors?.['required'];"><span translate>入力してください</span></mat-error>
							<mat-error *ngIf="email_field.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
						</mat-form-field>
					</div>

					<div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
						<mat-form-field appearance="outline" fxFlex="100" style="height: 80px;">
							<mat-label><span data-idtest="payment-customer-update-dialog-t-2Rq" translate>郵便番号</span></mat-label>
							<input data-idtest="payment-customer-update-dialog-i-7Wx" #address_postal_code_field="ngModel" (change)="changePostalCode()" [(ngModel)]="content.address.postal_code" autocomplete="off" matInput maxlength="100" name="address_postal_code" required type="text" style="color: #ffffff">
							<mat-error *ngIf="address_postal_code_field.errors?.['required'];"><span translate>入力してください</span></mat-error>
							<mat-error *ngIf="address_postal_code_field.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
						</mat-form-field>
					</div>

					<div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
						<mat-form-field appearance="outline" fxFlex="100" style="height: 80px;">
							<mat-label><span data-idtest="payment-customer-update-dialog-t-9Ag" translate>都道府県</span></mat-label>
							<input data-idtest="payment-customer-update-dialog-i-3Mf" #address_state_field="ngModel" [(ngModel)]="content.address.state" autocomplete="off" matInput maxlength="100" name="address_state" required type="text" style="color: #ffffff">
							<mat-error *ngIf="address_state_field.errors?.['required'];"><span translate>入力してください</span></mat-error>
							<mat-error *ngIf="address_state_field.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
						</mat-form-field>
					</div>

					<div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
						<mat-form-field appearance="outline" fxFlex="100" style="height: 80px;">
							<mat-label><span data-idtest="payment-customer-update-dialog-t-9Cj" translate>住所(市区町村)</span></mat-label>
							<input data-idtest="payment-customer-update-dialog-i-4Mi" #address_city_field="ngModel" [(ngModel)]="content.address.city" autocomplete="off" matInput maxlength="16" name="address_city" required type="text" style="color: #ffffff">
							<mat-error *ngIf="address_city_field.errors?.['required'];"><span translate>入力してください</span></mat-error>
							<mat-error *ngIf="address_city_field.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
						</mat-form-field>
					</div>

					<div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
						<mat-form-field appearance="outline" fxFlex="100" style="height: 80px;">
							<mat-label><span data-idtest="payment-customer-update-dialog-t-1Gz" translate>番地</span></mat-label>
							<input data-idtest="payment-customer-update-dialog-i-0Zt" #address_line1_field="ngModel" [(ngModel)]="content.address.line1" autocomplete="off" matInput maxlength="100" name="address_line1" required type="text" style="color: #ffffff">
							<mat-error *ngIf="address_line1_field.errors?.['required'];"><span translate>入力してください</span></mat-error>
							<mat-error *ngIf="address_line1_field.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
						</mat-form-field>
					</div>

					<div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
						<mat-form-field appearance="outline" fxFlex="100" style="height: 80px;">
							<mat-label><span data-idtest="payment-customer-update-dialog-t-5Ko" translate>マンション名</span></mat-label>
							<input data-idtest="payment-customer-update-dialog-i-4Ay" #address_line2_field="ngModel" [(ngModel)]="content.address.line2" autocomplete="off" matInput maxlength="100" name="address_line2" type="text" style="color: #ffffff">
							<mat-error *ngIf="address_line2_field.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
						</mat-form-field>
					</div>
				</div>
			</form>
	</mat-dialog-content>

	<div class="spacer"></div>

	<mat-dialog-actions fxLayoutAlign="center" fxLayoutAlign.lt-sm="center">
		<div fxFlex="100%" fxFlex.lt-sm="100%" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around" fxLayoutAlign.lt-sm="center">
			<button (click)="cancel()" [disabled]="isProgress" color="warn" mat-dialog-close="" mat-stroked-button fxFlex="30%" fxFlex.lt-sm="100%"><span data-idtest="payment-customer-update-dialog-t-4Fx" translate>閉じる</span></button>
			<button (click)="onAccept()" *ngIf="!form.invalid" [disabled]="form.invalid" color="primary" mat-raised-button fxFlex="30%" fxFlex.lt-sm="100%"><span data-idtest="payment-customer-update-dialog-t-9Wd" translate>更新</span></button>
			<button *ngIf="form.invalid" [disabled]="form.invalid" color="primary" mat-raised-button fxFlex="30%" fxFlex.lt-sm="100%"><span data-idtest="payment-customer-update-dialog-t-8Zd" translate>更新</span></button>
		</div>
	</mat-dialog-actions>

</div>
